<template>
  <div id="main_container">
    <b-card id="db_card">
      <!-- Options to add pc -->
      <div id="options_div">
        <b-form-select
          class="pc_input"
          id="country_input"
          @change="DownloadInventory"
          v-model="country_selected"
          :options="country_options"
        />
        <b-input type="text" class="pc_input" id="pc_name_input" placeholder="Name" />
        <b-input type="number" class="pc_input" id="pc_cpu_input" placeholder="CPU (ghz)" />
        <b-input type="text" class="pc_input" id="pc_link_input" placeholder="Link" />
        <b-input type="number" class="pc_input" id="pc_ram_input" placeholder="RAM (gb)" />
        <b-input type="number" class="pc_input" id="pc_storage_input" placeholder="Storage (gb)" />
        <b-input type="number" class="pc_input" id="pc_price_input" placeholder="Price ($$$)" />
        <b-form-select
          class="pc_input"
          id="pc_drive_input"
          v-model="drive_selected"
          :options="drive_options"
        />
        <b-form-select
          class="pc_input"
          id="pc_gpu_input"
          v-model="gpu_selected"
          :options="gpu_options"
        />
        <b-form-select
          class="pc_input"
          id="pc_os_input"
          v-model="os_selected"
          :options="os_options"
        />

        <!-- image -->
        <div class="custom-file mb-3">
          <input
            type="file"
            class="custom-file-input"
            id="picture_input"
            aria-describedby="picture_input"
          />
          <label class="custom-file-label" for="picture_input">Choose file</label>
        </div>

        <b-button variant="success" id="upload_btn" @click="UploadPc">Upload</b-button>
      </div>
      <hr />
      <b-table striped hover head-variant="dark" :items="inventory_data"></b-table>
      <hr />
      <div id="inventory_div"></div>
    </b-card>
  </div>
</template>

<script>
// imports
import firebase from "firebase";
import PictureInput from "vue-picture-input";

export default {
  name: "PcChooserAdmin",
  methods: {
    UploadPc: function () {
      let _this = this;
      // Change button state
      let uploadBtn = document.getElementById("upload_btn");
      uploadBtn.setAttribute("disabled", "");
      uploadBtn.innerHTML = "Loading...";

      let name_doc = document.getElementById("pc_name_input");
      let cpu_doc = document.getElementById("pc_cpu_input");
      let link_doc = document.getElementById("pc_link_input");
      let ram_doc = document.getElementById("pc_ram_input");
      let storage_doc = document.getElementById("pc_storage_input");
      let drive_doc = document.getElementById("pc_drive_input");
      let gpu_doc = document.getElementById("pc_gpu_input");
      let os_doc = document.getElementById("pc_os_input");
      let price_doc = document.getElementById("pc_price_input");

      // Get form values
      let values = {
        name: name_doc.value,
        cpu: cpu_doc.value,
        link: link_doc.value,
        ram: ram_doc.value,
        storage: storage_doc.value,
        drive: drive_doc.value,
        gpu: gpu_doc.value,
        os: os_doc.value,
        price: price_doc.value,
      };

      // upload to firestore
      let db = firebase.firestore();
      let docPath = document.getElementById("country_input").value;
      db.collection(docPath)
        .add({
          name: values.name,
          cpu: values.cpu,
          link: values.link,
          ram: values.ram,
          storage: values.storage,
          drive: values.drive,
          gpu: values.gpu,
          os: values.os,
          available: true,
          price: values.price,
        })
        .then(function (docRef) {
          // upload image to firebase storage
          let img = document.getElementById("picture_input").files[0];
          let storageRef = firebase.storage().ref(docPath);
          let imgRef = storageRef.child(docRef.id + ".jpg");
          imgRef
            .put(img)
            .then(function (snapshot) {
              // clear inputs
              name_doc.value = "";
              cpu_doc.value = "";
              link_doc.value = "";
              ram_doc.value = "";
              storage_doc.value = "";
              price_doc.value = "";
              drive_doc.selectedIndex = 0;
              gpu_doc.selectedIndex = 0;
              os_doc.selectedIndex = 0;

              // update image picker
              document.getElementById("picture_input").value = "";
              //document.querySelector(".custom-file-input").value = null;

              // restore button
              uploadBtn.removeAttribute("disabled");
              uploadBtn.innerHTML = "Upload";
              alert("Document written with ID: " + docRef.id);
              _this.DownloadInventory();
            })
            .catch(function (error) {
              alert("Error adding image: " + error.message);
              db.collection(docPath)
                .doc(docRef.id)
                .delete()
                .then(function () {
                  alert("Transaction succesfully canceled.");
                })
                .catch(function (error) {
                  alert("Couldn't remove document. \nError: " + error.message);
                });
              // restore button
              uploadBtn.removeAttribute("disabled");
              uploadBtn.innerHTML = "Upload";
            });
        })
        .catch(function (error) {
          alert(error.message);
        });
    },
    queryToJson: function (doc) {
      let auxPc = {
        id: doc.id,
        name: doc.data().name,
        cpu: doc.data().cpu,
        drive: doc.data().drive,
        gpu: doc.data().gpu,
        link: doc.data().link,
        os: doc.data().os,
        ram: doc.data().ram,
        storage: doc.data().storage,
        price: doc.data().price,
      };

      return auxPc;
    },
    CreateTextItem(value, name, pcId) {
      let inputGroup = document.createElement("div");
      inputGroup.className = "input-group mb-2";

      let inputGroupPrepend = document.createElement("div");
      inputGroupPrepend.className = "input-group-prepend";

      let span = document.createElement("span");
      span.className = "input-group-text";
      span.innerHTML = name;
      inputGroupPrepend.appendChild(span);
      inputGroup.appendChild(inputGroupPrepend);

      let input = document.createElement("input");
      input.type = "text";
      input.className = "form-control";
      input.id = pcId + "_" + name;
      input.value = value;
      if (name == "ID") input.disabled = true;
      inputGroup.appendChild(input);

      return inputGroup;
    },
    CreateNumberItem(value, name, pcId) {
      let inputGroup = document.createElement("div");
      inputGroup.className = "input-group mb-2";

      let inputGroupPrepend = document.createElement("div");
      inputGroupPrepend.className = "input-group-prepend";

      let span = document.createElement("span");
      span.className = "input-group-text";
      span.innerHTML = name;
      inputGroupPrepend.appendChild(span);
      inputGroup.appendChild(inputGroupPrepend);

      let input = document.createElement("input");
      input.type = "number";
      input.className = "form-control";
      input.id = pcId + "_" + name;
      input.value = value;
      if (name == "ID") input.disabled = true;
      inputGroup.appendChild(input);

      return inputGroup;
    },
    CreateSelectItem(value, name, pcId) {
      let inputGroup = document.createElement("div");
      inputGroup.className = "input-group mb-2";

      let inputGroupPrepend = document.createElement("div");
      inputGroupPrepend.className = "input-group-prepend";

      let span = document.createElement("span");
      span.className = "input-group-text";
      span.innerHTML = name;
      inputGroupPrepend.appendChild(span);
      inputGroup.appendChild(inputGroupPrepend);

      let select = document.createElement("select");
      select.className = "custom-select";
      select.id = pcId + "_" + name;
      let selectedOption = document.createElement("option");
      selectedOption.setAttribute("selected", "");
      selectedOption.innerHTML = value;
      select.appendChild(selectedOption);
      // iterate over options
      switch (name) {
        case "Drive":
          this.drive_options.forEach(function (item) {
            if (item.value != value && item.value != null) {
              let option = document.createElement("option");
              option.value = item.value;
              option.innerHTML = item.text;
              select.appendChild(option);
            }
          });
          break;
        case "GPU":
          this.gpu_options.forEach(function (item) {
            if (item.value != value && item.value != null) {
              let option = document.createElement("option");
              option.value = item.value;
              option.innerHTML = item.text;
              select.appendChild(option);
            }
          });
          break;
        case "OS":
          this.os_options.forEach(function (item) {
            if (item.value != value && item.value != null) {
              let option = document.createElement("option");
              option.value = item.value;
              option.innerHTML = item.text;
              select.appendChild(option);
            }
          });
          break;
      }

      inputGroup.appendChild(select);

      return inputGroup;
    },
    CreateItemHtml: function (pc) {
      let _this = this;
      // create container div
      let itemDiv = document.createElement("div");
      itemDiv.style.display = "flex";
      itemDiv.style.flexDirection = "row";

      // create left div
      let leftDiv = document.createElement("div");
      leftDiv.style.display = "grid";
      leftDiv.style.width = "25vw";
      let pcComponents = document.createElement("div");

      // Create list items
      pcComponents.appendChild(this.CreateTextItem(pc.name, "Name", pc.id));
      pcComponents.appendChild(this.CreateTextItem(pc.id, "ID", pc.id));
      pcComponents.appendChild(this.CreateNumberItem(pc.cpu, "CPU", pc.id));
      pcComponents.appendChild(this.CreateSelectItem(pc.drive, "Drive", pc.id));
      pcComponents.appendChild(this.CreateSelectItem(pc.gpu, "GPU", pc.id));
      pcComponents.appendChild(this.CreateTextItem(pc.link, "Link", pc.id));
      pcComponents.appendChild(this.CreateSelectItem(pc.os, "OS", pc.id));
      pcComponents.appendChild(this.CreateNumberItem(pc.ram, "RAM", pc.id));
      pcComponents.appendChild(this.CreateNumberItem(pc.price, "Price", pc.id));
      pcComponents.appendChild(
        this.CreateNumberItem(pc.storage, "Storage", pc.id)
      );

      // create edit button
      let editPcButton = document.createElement("button");
      editPcButton.className = "btn btn-primary mb-2";
      editPcButton.innerHTML = "Update";
      editPcButton.style.fontSize = "1.1rem";
      editPcButton.style.width = "25vw";
      editPcButton.onclick = function () {
        // button status
        editPcButton.innerHTML = "Loading...";
        editPcButton.disabled = true;

        // set firestore reference
        let db = firebase.firestore();
        let ref = document.getElementById("country_input").value;
        let doc = db.collection(ref).doc(pc.id);

        // get pc values
        let pc_name = document.getElementById(pc.id + "_Name").value;
        let pc_cpu = document.getElementById(pc.id + "_CPU").value;
        let pc_drive = document.getElementById(pc.id + "_Drive").value;
        let pc_gpu = document.getElementById(pc.id + "_GPU").value;
        let pc_link = document.getElementById(pc.id + "_Link").value;
        let pc_os = document.getElementById(pc.id + "_OS").value;
        let pc_ram = document.getElementById(pc.id + "_RAM").value;
        let pc_storage = document.getElementById(pc.id + "_Storage").value;
        let pc_price = document.getElementById(pc.id + "_Price").value;

        // update document in db
        doc
          .set({
            cpu: pc_cpu,
            drive: pc_drive,
            gpu: pc_gpu,
            link: pc_link,
            name: pc_name,
            os: pc_os,
            ram: pc_ram,
            storage: pc_storage,
            price: pc_price,
          })
          .then(function () {
            // PC updated with success
            alert("PC updated successfully");
            editPcButton.innerHTML = "Update";
            editPcButton.disabled = false;
          })
          .catch(function (error) {
            // an error occurred while updating pc
            alert(error.message);
            editPcButton.innerHTML = "Update";
            editPcButton.disabled = false;
          });
      };

      // create delete button
      let deletePcButton = document.createElement("button");
      deletePcButton.className = "btn btn-danger";
      deletePcButton.innerHTML = "Delete";
      deletePcButton.style.fontSize = "1.1rem";
      deletePcButton.style.width = "25vw";
      deletePcButton.onclick = function () {
        if (confirm("Are you sure you want to delete this item?")) {
          // button status
          deletePcButton.innerHTML = "Loading...";
          deletePcButton.disabled = true;

          // set firestore reference
          let db = firebase.firestore();
          let ref = document.getElementById("country_input").value;
          let doc = db.collection(ref).doc(pc.id);

          // delete
          doc
            .delete()
            .then(function () {
              alert("PC successfully deleted.");

              // update html
              _this.DownloadInventory();
            })
            .catch(function (error) {
              alert(error.message);
              // restore button
              deletePcButton.innerHTML = "Delete";
              deletePcButton.disabled = false;
            });
        }
      };

      // Add list, then edit button, and add image
      leftDiv.appendChild(pcComponents);
      leftDiv.appendChild(editPcButton);
      leftDiv.appendChild(deletePcButton);
      itemDiv.appendChild(leftDiv);

      // download image
      let pc_country = document.getElementById("country_input").value;
      let imgReference = firebase.storage().ref(`${pc_country}/${pc.id}.jpg`);

      imgReference
        .getDownloadURL()
        .then(function (url) {
          // create right div and image elements
          let rightDiv = document.createElement("div");
          rightDiv.style.marginLeft = "5vw";
          let imgElement = document.createElement("img");
          imgElement.setAttribute("src", url);
          imgElement.style.maxHeight = "67vh";
          imgElement.style.maxWidth = "45vw";

          // add to item div
          rightDiv.appendChild(imgElement);
          itemDiv.appendChild(rightDiv);
        })
        .catch(function (error) {
          alert(error.message);
        });

      return itemDiv;
    },
    FillInventoryDiv: function (pcs) {
      let inventoryDiv = document.getElementById("inventory_div");
      inventoryDiv.innerHTML = "";
      for (let i = 0; i < pcs.length; i++) {
        // add item to the inventory div
        let auxItem = this.CreateItemHtml(pcs[i]);
        if (auxItem != null) inventoryDiv.appendChild(auxItem);

        // only add <hr/> if i isn't te last item
        if (i != pcs.length - 1) {
          let hr = document.createElement("hr");
          hr.style.margin = "0";
          hr.style.alignSelf = "stretch";
          hr.style.marginTop = "3vh";
          hr.style.marginBottom = "3vh";
          inventoryDiv.appendChild(hr);
        }
      }
    },
    DownloadInventory: function () {
      // read db and get existing inventory
      let pcs = [];
      let _this = this;
      let db = firebase.firestore();
      let ref = document.getElementById("country_input").value;

      // clear inventory count data
      _this.inventory_data[0].totalCount = 0;
      _this.inventory_data[0].available = 0;
      _this.inventory_data[0].unavailable = 0;

      db.collection(ref)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // save data and store it in an array
            _this.inventory_data[0].totalCount += 1;
            if (doc.data().available) _this.inventory_data[0].available += 1;
            else _this.inventory_data[0].unavailable += 1;
            pcs.push(_this.queryToJson(doc));
          });

          // fill inventory div
          _this.FillInventoryDiv(pcs);
        })
        .catch(function (error) {
          alert(error.message);
        });
    },
  },
  mounted() {
    let _this = this;

    // check if user is authorized to access this feature
    firebase.auth().onAuthStateChanged(function (user) {
      if (!user) {
        // user isn't signed in
        alert("You don't have permission to access this feature.");
        _this.$router.push("/");
      }
    });

    // set inventory in html
    this.DownloadInventory();

    // update image picker name
    document
      .querySelector(".custom-file-input")
      .addEventListener("change", function (e) {
        var fileName = document.getElementById("picture_input").files[0].name;
        var nextSibling = e.target.nextElementSibling;
        nextSibling.innerText = fileName;
      });
  },
  data() {
    return {
      gpu_selected: null,
      gpu_options: [
        { value: null, text: "GPU" },
        { value: "None", text: "None" },
        { value: "Low", text: "Low" },
        { value: "Mid", text: "Mid" },
        { value: "High", text: "High" },
      ],
      os_selected: null,
      os_options: [
        { value: null, text: "OS" },
        { value: "Windows 10", text: "Windows 10" },
        { value: "Mac OS", text: "Mac OS" },
        { value: "Google Chrome", text: "Google Chrome" },
        { value: "Ubuntu", text: "Ubuntu" },
      ],
      drive_selected: null,
      drive_options: [
        { value: null, text: "Drive" },
        { value: "HDD", text: "HDD" },
        { value: "SSD", text: "SSD" },
      ],
      country_selected: "pc_usa",
      country_options: [
        { value: "pc_usa", text: "United States" },
        { value: "pc_mex", text: "Mexico" },
      ],
      inventory_data: [{ totalCount: 0, available: 0, unavailable: 0 }],
    };
  },
};
</script>

<style scoped>
#main_container {
  background-color: mediumslateblue;
  padding-top: 10vh;
  padding-bottom: 10vh;
}

#db_card {
  margin-left: auto;
  margin-right: auto;
  max-width: 80vw;
}

#options_div {
  padding-left: 10vw;
  padding-right: 10vw;
}

#upload_btn {
  padding-top: 0.4vh;
  padding-bottom: 0.4vh;
  font-size: 1.3rem;
}

.pc_input {
  margin-bottom: 1vh;
}
</style>


// WEBPACK FOOTER //
// src/components/PcChooserAdmin.vue